import React from "react"
import { css } from "@emotion/core"

class CommentList extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return this.props.comments.edges.map(({ node }) => (
      <div
        css={css`
          margin-bottom: 50px;
        `}
      >
        <div
          css={css`
            font-family: monospace;
            font-size: 18px;
            padding-bottom: 3px;
            border-bottom: 1px solid #ccc;
            margin-bottom: 18px;
          `}
        >
          <span
            css={css`
              font-weight: 600;
            `}
          >
            {node.name}
          </span>
        </div>
        <div
          css={css`
            white-space: pre-wrap;
          `}
        >
          {node.message}
        </div>
      </div>
    ))
  }
}

export default CommentList
